import { createAxios } from "@/utils/axios";

export const request = createAxios();
